import React, { useEffect, useState } from "react";
import BaseModal from "./BaseModal";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../store";
import {
  setAddPaymentMethodModal,
  setIsMethodeAdded,
} from "../../store/reducers/modal.reducer";
import { Elements } from "@stripe/react-stripe-js";
import BillingPaymentMethodsForm from "../user/billings/BillingPaymentMethodsForm";
import { loadStripe, StripeElementsOptions } from "@stripe/stripe-js";
import { useHubstripe } from "../../hooks/useHubstripe";
import { TBilling } from "../../shared/types/billing.type";
import { isEmpty } from "lodash";
import { THubstripeCustomer } from "../../shared/types/hubstripeCustomer.type";
import {
  Box,
  Button,
  CircularProgress,
  Skeleton,
  Typography,
} from "@mui/material";
import { useQueryClient } from "react-query";
import { toast } from "react-toastify";
import { t } from "i18next";
import { ErrorOutline } from "@mui/icons-material";

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLIC_KEY ?? "");

function AddPaymentMethodeModal() {
  const open = useSelector<RootState>(
    (state) => state.modals.addPaymentMethodModal,
  ) as boolean;
  const dispatch = useDispatch();
  const billings = useSelector<RootState>(
    (state) => state.user.user?.user_billing_infos,
  ) as TBilling[];
  const [customer, setCustomer] = useState<THubstripeCustomer | null>(null);
  const [stripeId, setStripeId] = useState<string | null>(null);

  const { getCustomerFromCustomerId } = useHubstripe();
  const queryClient = useQueryClient();

  useEffect(() => {
    if (isEmpty(billings) || !open) return;

    let stripe_id = (billings || []).at(0)?.stripe_id;

    if (!stripe_id) return;

    setStripeId(stripeId);

    fetchCustomer(stripe_id as string);
  }, [billings?.length, open]);

  const options: StripeElementsOptions = {
    mode: "setup",
    // currency: customer?.currency ?? 'usd',
    currency: "usd",
    // Fully customizable with appearance API.
    appearance: {
      theme: "stripe",
    },
  };

  const fetchCustomer = async (stripe_id: string) => {
    try {
      let response = await getCustomerFromCustomerId.mutateAsync(stripe_id);
      setCustomer(response.data?.customer ?? null);
    } catch (error) {
      toast(t("error:generic"), { type: "error" });
    }
  };

  const handleClose = () => {
    dispatch(setAddPaymentMethodModal(false));
  };

  const onFailure = () => {
    toast(t("error:generic"), { type: "error" });
  };

  const onPaymentMethodeAdded = () => {
    handleClose();
    queryClient.refetchQueries(["eqms"]);
    dispatch(setIsMethodeAdded(true));
  };

  if (!open) return null;

  return (
    <BaseModal
      open={open}
      handleClose={handleClose}
      title=""
      width={500}
      
      styleProps={{
        backgroundColor: customer
          ? "#eee !important"
          : "rgba(33, 43, 54, 1) !important",
        }}
    >
      {getCustomerFromCustomerId.isLoading ? (
        <Skeleton width={"100%"} height={160} variant="rectangular"></Skeleton>
      ) : customer ? (
        <Elements stripe={stripePromise} options={options}>
          <BillingPaymentMethodsForm
            customer={customer}
            onSuccess={onPaymentMethodeAdded}
            onFailure={onFailure}
          />
        </Elements>
      ) : (
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            textAlign: "center",
            py: 6,
            px: 3,
            gap: 1.5,
          }}
        >
          <ErrorOutline sx={{ fontSize: 48, color: "text.disabled" }} />
          <Typography variant="subtitle1" fontWeight={600}>
            {t('billing:customerNotFound')}
          </Typography>
          <Typography
            variant="body2"
            color="text.secondary"
            sx={{ maxWidth: 320 }}
          >
            {t('billing:customerNotFoundHint')}
            
          </Typography>
          <Button
            component="a"
            href="mailto:support@arioneo.com"
            variant="contained"
            size="small"

            sx={{ mt: 1 }}
          >
            {t('billing:customerNotFoundCta ',{email:"support@arioneo.com"})}
          </Button>
        </Box>
      )}
      {/* Stripe */}
    </BaseModal>
  );
}

export default AddPaymentMethodeModal;
